/* nx-motion-figures.js — графиките и числата (D): времето до старт, стъпките, времевата линия,
   везната и фактите в кейсовете. Крайният вид стои в HTML и CSS; тук само задаваме началото,
   когато фигурата стигне екрана, и я пускаме. Без ядрото (window.NX) не правим нищо. */
(function () {
  if (window.__nxFig) return; window.__nxFig = true;
  if (!window.NX || !window.gsap) return;
  var NX = window.NX, gsap = window.gsap, ST = window.ScrollTrigger;

  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
  function motion(flags) { return flags ? !!flags.motion : !matchMedia('(prefers-reduced-motion: reduce)').matches; }
  function inView(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < (window.innerHeight || document.documentElement.clientHeight);
  }

  /* водещото цяло число: „1697 продукта" → 1697, „89 от 95" → 89; „Две", „Stivo 2.0", „2.5 сек" → null */
  function leadInt(s) {
    s = String(s == null ? '' : s).trim();
    var m = /^\d[\d\s]*/.exec(s);
    if (!m) return null;
    var raw = m[0].replace(/\s+$/, '');
    if (/^[.,]\d/.test(s.slice(raw.length))) return null;
    return { text: raw, value: parseInt(raw.replace(/\s/g, ''), 10) };
  }

  /* брояч: през ядрото, ако го има; иначе локално. Текстът се връща точно какъвто е бил */
  function count(el, to, dur) {
    var o = { from: 0, to: to, duration: dur, ease: 'power2.out' };
    if (typeof NX.count === 'function') return NX.count(el, o);
    var s = { v: 0 };
    return gsap.to(s, { v: to, duration: dur, ease: o.ease,
      onUpdate: function () { el.textContent = String(Math.round(s.v)); } });
  }

  /* началото се задава, когато горният ръб влезе отдолу (още невидимо), пуска се при play.
     clamp() пази старта достижим и за фигура близо до края на страницата */
  function stage(el, play, prime, run) {
    var primed = false;
    function p() { if (!primed) { primed = true; prime(); } }
    ST.create({ trigger: el, start: 'top bottom', once: true, onEnter: p });
    ST.create({ trigger: el, start: 'clamp(' + play + ')', once: true, onEnter: function () { p(); run(); } });
  }

  /* половината от точката — псевдоелементите са content-box, затова броим и рамката */
  function half(cs, axis) {
    var a = axis === 'y' ? ['height', 'borderTopWidth', 'borderBottomWidth'] : ['width', 'borderLeftWidth', 'borderRightWidth'];
    var v = (parseFloat(cs[a[0]]) || 14) + (parseFloat(cs[a[1]]) || 0) + (parseFloat(cs[a[2]]) || 0);
    return v / 2;
  }

  /* 1. „Време до старт": агенцията пълзи 2,6 с, месеците светват, докато ги минава;
        на 0,4 с нашата линия се забива за 0,5 с, точката изскача, числото брои до 7 */
  NX.register('tchart', '[data-nx="tchart"]', function (fig, flags) {
    if (!motion(flags) || !ST || inView(fig)) return;
    var ours = fig.querySelector('.tc-ours'), theirs = fig.querySelector('.tc-theirs');
    if (!ours || !theirs) return;
    var oBar = ours.querySelector('.tc-bar'), oDot = ours.querySelector('.tc-dot'), oVal = ours.querySelector('.tc-value');
    var tBar = theirs.querySelector('.tc-bar'), tDot = theirs.querySelector('.tc-dot'), tVal = theirs.querySelector('.tc-value');
    var months = $$(fig, '.tc-scale text');
    var num = fig.querySelector('[data-nx-num]'), numText = num ? num.textContent : '', n = num ? leadInt(numText) : null;
    var x1 = +tBar.getAttribute('x1'), x2 = +tBar.getAttribute('x2');
    var CRAWL = 2.6, tl, ctx;

    function build() {
      gsap.set([oBar, tBar], { strokeDashoffset: 1 });
      gsap.set([oDot, tDot], { opacity: 0, '--nx-s': 0 });
      gsap.set([oVal, tVal], { opacity: 0 });
      gsap.set(months, { opacity: .35 });
      if (n) num.textContent = '0';

      tl = gsap.timeline({ paused: true });
      tl.to(tBar, { strokeDashoffset: 0, duration: CRAWL, ease: 'none' }, 0);
      months.forEach(function (m) {
        var f = clamp01((+m.getAttribute('x') - x1) / ((x2 - x1) || 1));
        tl.to(m, { opacity: 1, duration: .35, ease: 'power1.out' }, f * CRAWL);
      });
      tl.to(oBar, { strokeDashoffset: 0, duration: .5, ease: 'power4.out' }, .4)
        .to(oDot, { opacity: 1, duration: .12 }, .78)
        .to(oDot, { '--nx-s': 1, duration: .5, ease: 'back.out(3)' }, .78)
        .to(oVal, { opacity: 1, duration: .35 }, .85);
      if (n) tl.call(function () {
        ctx.add(function () {
          count(num, n.value, 1.1);
          gsap.delayedCall(1.15, function () { num.textContent = numText; });
        });
      }, null, .85);
      tl.to(tDot, { opacity: 1, duration: .12 }, CRAWL)
        .to(tDot, { '--nx-s': 1, duration: .5, ease: 'back.out(3)' }, CRAWL)
        .to(tVal, { opacity: 1, duration: .45, ease: 'power1.out' }, CRAWL);
    }

    ctx = gsap.context(function () {
      stage(fig, 'top 60%',
        function () { ctx.add(build); },
        function () { tl.play(); });
    }, fig);
    return function () { ctx.revert(); if (num) num.textContent = numText; };
  });

  /* 2. Стъпките: линията следва скрола (--nx-p върху .steps), точката се пълни, когато я мине.
        Хоризонтално на десктоп, вертикално под 900 px — посоката идва от CSS (--nx-axis) */
  NX.register('steps', '[data-nx="steps"]', function (root, flags) {
    if (!motion(flags) || !ST) return;
    var steps = $$(root, '.step');
    if (!steps.length) return;
    var marks = [], state = [], ctx, tw;
    function inCtx(fn) { ctx ? ctx.add(fn) : fn(); }

    function measure() {
      var y = (getComputedStyle(root).getPropertyValue('--nx-axis') || '').trim() === 'y';
      var line = getComputedStyle(root, '::after');
      if (y) {
        var y0 = parseFloat(line.top) || 0, len = parseFloat(line.height) || (root.clientHeight - y0);
        marks = steps.map(function (s) {
          var d = getComputedStyle(s, '::before');
          return (s.offsetTop + (parseFloat(d.top) || 0) + half(d, 'y') - y0) / Math.max(1, len);
        });
      } else {
        var w = root.clientWidth || 1;
        marks = steps.map(function (s) { return (s.offsetLeft + half(getComputedStyle(s, '::before'), 'x')) / w; });
      }
    }
    function sync(p, now) {
      steps.forEach(function (s, i) {
        var on = p > 0 && p >= marks[i] - .002 ? 1 : 0;
        if (state[i] === on) return;
        state[i] = on;
        inCtx(function () {
          gsap.to(s, { '--nx-on': on, duration: now ? 0 : on ? .35 : .2, ease: 'power2.out', overwrite: true });
        });
      });
    }

    ctx = gsap.context(function () {
      measure();
      tw = gsap.fromTo(root, { '--nx-p': 0 }, {
        '--nx-p': 1, ease: 'none',
        scrollTrigger: { trigger: root, start: 'top 70%', end: 'bottom 65%', scrub: .5,
          onRefresh: function () { measure(); if (tw) sync(tw.progress(), true); } },
        onUpdate: function () { sync(this.progress()); }
      });
      sync(0, true);
    }, root);
    return function () {
      ctx.revert();
      root.style.removeProperty('--nx-p');
      steps.forEach(function (s) { gsap.killTweensOf(s); s.style.removeProperty('--nx-on'); });
    };
  });

  /* 3. Времевата линия 0 / 7 / 30 / 60: запълването следва скрола, възлите изскачат, когато ги стигне */
  NX.register('ftime', '[data-nx="ftime"]', function (fig, flags) {
    if (!motion(flags) || !ST) return;
    var fill = fig.querySelector('.ft-fill'), nodes = $$(fig, '.ft-node');
    if (!fill || !nodes.length) return;
    var x1 = +fill.getAttribute('x1'), x2 = +fill.getAttribute('x2');
    var parts = nodes.map(function (g) {
      var dot = g.querySelector('.ft-dot');
      return { dot: dot, txt: $$(g, '.ft-day, .ft-lbl'),
        at: clamp01((+dot.getAttribute('cx') - x1) / ((x2 - x1) || 1)) };
    });
    var state = [], ctx;
    function inCtx(fn) { ctx ? ctx.add(fn) : fn(); }

    function sync(p, now) {
      parts.forEach(function (n, i) {
        var on = p > 0 && p >= n.at - .002 ? 1 : 0;
        if (state[i] === on) return;
        state[i] = on;
        inCtx(function () {
          gsap.to(n.dot, { '--nx-s': on ? 1 : .6, opacity: on ? 1 : .5, overwrite: true,
            duration: now ? 0 : on ? .5 : .25, ease: on ? 'back.out(3)' : 'power1.out' });
          gsap.to(n.txt, { opacity: on ? 1 : .35, overwrite: true, duration: now ? 0 : on ? .3 : .2, ease: 'power1.out' });
        });
      });
    }

    ctx = gsap.context(function () {
      gsap.fromTo(fill, { strokeDashoffset: 1 }, {
        strokeDashoffset: 0, ease: 'none',
        scrollTrigger: { trigger: fig, start: 'top 70%', end: 'bottom 60%', scrub: .5 },
        onUpdate: function () { sync(this.progress()); }
      });
      sync(0, true);
    }, fig);
    return function () { ctx.revert(); };
  });

  /* 4. Везната: наклонът си остава в CSS; числата 4 и 3 броят, докато блюдата се успокоят */
  NX.register('fscale', '[data-nx="fscale"]', function (fig, flags) {
    if (!motion(flags) || fig.classList.contains('is-on')) return;
    var nums = $$(fig, '.fx-num').map(function (el) { return { el: el, text: el.textContent, n: leadInt(el.textContent) }; })
      .filter(function (x) { return x.n; });
    if (!nums.length || !('MutationObserver' in window)) return;
    var ctx = gsap.context(function () {}, fig);
    function restore() { nums.forEach(function (x) { x.el.textContent = x.text; }); }
    var mo = new MutationObserver(function () {
      if (!fig.classList.contains('is-on')) return;
      mo.disconnect();
      ctx.add(function () {
        /* числата се появяват с 1,1 с закъснение (nexum-fix.css) — броим точно тогава */
        gsap.delayedCall(1.05, function () {
          ctx.add(function () {
            nums.forEach(function (x) { x.el.textContent = '0'; count(x.el, x.n.value, .9); });
            gsap.delayedCall(.95, restore);
          });
        });
      });
    });
    mo.observe(fig, { attributes: true, attributeFilter: ['class'] });
    return function () { mo.disconnect(); ctx.revert(); restore(); };
  });

  /* 5. Фактите в кейсовете: броим само водещото цяло число; вариантът „rule" дорисува чертата */
  NX.register('facts', '[data-nx="facts"]', function (root, flags) {
    if (!motion(flags) || !ST) return;
    var rule = root.classList.contains('cs-facts--rule');
    var cards = $$(root, '.cs-fact').filter(function (c) { return !inView(c); });
    if (!cards.length) return;
    var items = cards.map(function (c) {
      var el = c.querySelector('[data-nx-num]'), n = el ? leadInt(el.textContent) : null;
      return { el: n ? el : null, text: el ? el.textContent : '', n: n,
        lbl: rule ? c.querySelector('.cs-fact-lbl') : null, primed: false };
    });
    var ctx;
    function item(c) { return items[cards.indexOf(c)]; }
    function prime(it) {
      if (!it || it.primed) return;
      it.primed = true;
      if (it.el) it.el.textContent = '0';
      if (it.lbl) gsap.set(it.lbl, { '--nx-rule': 0 });
    }
    function play(batch) {
      batch.forEach(function (c, i) {
        var it = item(c);
        if (!it) return;
        prime(it);
        if (it.lbl) gsap.to(it.lbl, { '--nx-rule': 1, duration: .8, ease: 'power3.out', delay: i * .1 });
        if (it.el) gsap.delayedCall(i * .1, function () {
          ctx.add(function () {
            count(it.el, it.n.value, 1.1);
            gsap.delayedCall(1.15, function () { it.el.textContent = it.text; });
          });
        });
      });
    }
    ctx = gsap.context(function () {
      ST.batch(cards, { start: 'top bottom', once: true,
        onEnter: function (b) { ctx.add(function () { b.forEach(function (c) { prime(item(c)); }); }); } });
      ST.batch(cards, { start: 'clamp(top 85%)', once: true,
        onEnter: function (b) { ctx.add(function () { play(b); }); } });
    }, root);
    return function () { ctx.revert(); items.forEach(function (it) { if (it.el) it.el.textContent = it.text; }); };
  });
})();
